import { LOGOS } from "../../constants/brand";

export const SidebarLogo = () => (
  <div className="flex items-center gap-3">
    <img
      src={LOGOS.ICON_GRADIENT}
      alt="M"
      className="w-10 h-10 object-contain"
    />
    <div>
      <span className="text-lg xl:text-xl font-bold tracking-tight text-white">METHOS</span>
      <div className="flex items-center gap-1.5">
        <div className="w-1.5 h-1.5 rounded-full bg-[#F26A4B]" />
        <p className="text-[10px] text-white/50">Corretora</p>
      </div>
    </div>
  </div>
);

export const MobileHeaderLogo = () => (
  <img
    src={LOGOS.WORDMARK}
    alt="Methos - Corretora"
    className="h-7 sm:h-8 object-contain"
    style={{ clipPath: "inset(0 0 15% 0)" }}
    data-testid="mobile-header-logo"
  />
);

export const MobileMenuLogo = () => (
  <div className="flex items-center gap-2">
    <img
      src={LOGOS.ICON_GRADIENT}
      alt="M"
      className="w-8 h-8 object-contain"
    />
    <span className="font-bold text-white">METHOS</span>
  </div>
);
